"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopularityMetricsPatcheSchema = void 0;
exports.PopularityMetricsPatcheSchema = {
    "$id": "https://www.redbull.com/schemas/patch/popularity.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "PopularityMetricsPatche",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "rrn:content:[a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}"
        },
        "type": {
            "type": "string",
            "pattern": "rrn:patch:popularity"
        },
        "meta": {
            "type": "object",
            "properties": {
                "analyticsContentTrackingParams": {
                    "type": "number"
                }
            },
            "required": [
                "analyticsContentTrackingParams"
            ]
        }
    },
    "required": [
        "id",
        "meta",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9wdWxhcml0eS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9wYXRjaC9wb3B1bGFyaXR5LnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLEtBQUssRUFBRSw4REFBOEQ7SUFDckUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUseUJBQXlCO0lBQ2xDLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLDRGQUE0RjtTQUN4RztRQUNELE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxzQkFBc0I7U0FDbEM7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osZ0NBQWdDLEVBQUU7b0JBQ2hDLE1BQU0sRUFBRSxRQUFRO2lCQUNqQjthQUNGO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLGdDQUFnQzthQUNqQztTQUNGO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixJQUFJO1FBQ0osTUFBTTtRQUNOLE1BQU07S0FDUDtDQUNGLENBQUEifQ==